<template>
  <ts-card>
    <div class="form-header ts-bg-gray-100 ts-border-b ts-border-gray-400 ts-p-4 ts-relative">
      <h4 class="ts-text-sm">{{ $t('nationality.pageTitle') }}</h4>
      <ts-modal-close-button />
    </div>
    <ts-card-wrapper>
      <form>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('nationality.nationalityNameKh') }}</label>
              <div>
                <ts-input
                  v-model="model.nationality_name_kh"
                  :class="{ 'is-invalid': errors.has('nationality_name_kh') }"
                />
                <div class="invalid-feedback" v-if="errors.has('nationality_name_kh')">
                  {{ errors.first('nationality_name_kh') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-12">
            <div class="form-group m-b-10">
              <label class="col-form-label control-label required">{{ $t('nationality.nationalityNameEn') }}</label>
              <div>
                <ts-input
                  v-model="model.nationality_name_en"
                  :class="{ 'is-invalid': errors.has('nationality_name_en') }"
                />
                <div class="invalid-feedback" v-if="errors.has('nationality_name_en')">
                  {{ errors.first('nationality_name_en') }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row ts-mt-6">
          <div class="col-sm-12 col-lg-12 col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')" :disabled="saving">{{ $t('button.cancel') }}</ts-button>
            <ts-button color="primary" class="ml-2" :waiting="saving" @click.prevent="submit">{{
              editData ? $t('button.update') : $t('button.save')
            }}</ts-button>
          </div>
        </div>
      </form>
    </ts-card-wrapper>
  </ts-card>
</template>

<script>
import { Errors } from 'form-backend-validation'

export default {
  name: 'nationality-form',
  props: ['editData'],
  data() {
    return {
      model: {
        nationality_name_kh: '',
        nationality_name_en: ''
      },
      errors: new Errors(),
      saving: false
    }
  },
  created() {
    this.setEditData()
  },
  methods: {
    submit() {
      let response

      this.errors = new Errors()
      this.saving = true

      if (this.editData) {
        response = this.$store.dispatch('hr/nationality/update', {
          id: this.editData.nationality_id,
          ...this.model
        })
      } else {
        response = this.$store.dispatch('hr/nationality/create', this.model)
      }

      response
        .then(response => {
          this.$store.dispatch('hr/nationality/fetch').then(() => {
            this.saving = false
            this.$toasted.success(response.message)
            this.$emit('close')
          })
        })
        .catch(error => {
          this.saving = false
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
        })
    },
    setEditData() {
      if (!_.isEmpty(this.editData)) {
        this.model = {
          nationality_name_kh: this.editData.nationality_name_kh,
          nationality_name_en: this.editData.nationality_name_en
        }
      }
    }
  }
}
</script>
